$(document).ready(function () {

    $('section, footer').addClass('visible');

});